import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js';

import { CountryCodes } from 'src/shared/enum/Countries';

const DEFAULT_CALLING_CODE = '44';

export function parseThirdPartyPhone(thirdPartyCallingCode?: string, number?: string) {
    if (!number)
        return {
            countryCode: CountryCodes.UK,
            callingCode: DEFAULT_CALLING_CODE,
            number: '',
        };

    const callingCode = thirdPartyCallingCode || DEFAULT_CALLING_CODE;

    const countryCode = getCountries().find(
        (country) => getCountryCallingCode(country) === callingCode
    ) as CountryCode;

    return {
        countryCode: countryCode || CountryCodes.UK,
        callingCode,
        number,
    };
}
